"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSize = exports.SizeProvider = void 0;
var _react = require("react");
var SizeContext = /*#__PURE__*/(0, _react.createContext)(null);
var SizeProvider = exports.SizeProvider = SizeContext.Provider;
var useSize = exports.useSize = function useSize() {
  var context = (0, _react.useContext)(SizeContext);
  if (!context) {
    throw new Error('Please wrap the component under SizeProvider');
  }
  return context;
};